/**
 * Customizable Dashboard — zod schemas + persisted types.
 */
import { z } from 'zod';
import { DASHBOARD_LAYOUT_SCHEMA_VERSION } from './constants.js';
import { DASHBOARD_WIDGET_IDS } from './widget-registry.js';
export const dashboardWidgetIdSchema = z.enum(DASHBOARD_WIDGET_IDS);
/** A single placed widget in the canonical (desktop) layout. */
export const dashboardWidgetLayoutItemSchema = z.object({
    id: dashboardWidgetIdSchema,
    enabled: z.boolean(),
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive(),
});
/** The canonical persisted dashboard layout (post-normalization shape). */
export const dashboardLayoutSchema = z.object({
    schemaVersion: z.literal(DASHBOARD_LAYOUT_SCHEMA_VERSION),
    widgets: z.array(dashboardWidgetLayoutItemSchema),
    updatedAt: z.string().optional(),
});
/**
 * Loose inbound schema for client → server PATCH payloads. Intentionally
 * permissive: every field is treated as untrusted and re-validated/clamped by
 * `normalizeDashboardLayout`. We only require that `layout.widgets` is an array.
 */
export const incomingDashboardLayoutSchema = z.object({
    schemaVersion: z.number().optional(),
    widgets: z.array(z.unknown()),
    updatedAt: z.string().optional(),
});
export const patchDashboardLayoutBodySchema = z.object({
    layout: incomingDashboardLayoutSchema,
});
//# sourceMappingURL=schema.js.map